import React from "react";
import {Alert, Form, Spinner, Container, Row, Col} from "react-bootstrap";
import { withTranslation } from "react-i18next";
import ValidationHelper from "../../../../helpers/ValidationHelper";
import CamplaCoreService from "../../../../services/CamplaCoreService";
import BaseDialog from "../../../../components/dialogs/baseDialog/BaseDialog";
import BaseSelect from "../../../../components/baseSelect/BaseSelect";
import Switch from "react-switch";
import QRCode from "react-qr-code";

class UpdateUserDialog extends React.Component {
  constructor(props) {
    super(props);
    this.validationDefinition = {
      role: {
        defaultValue: undefined,
        initValid: false,
        rule: (value) => ValidationHelper.isIntInRange(value, 0, 1)
      },
      hasInternalLogin: {
        defaultValue: false,
        initValid: true,
        rule: ValidationHelper.isBoolean
      },
      password: {
        defaultValue: "",
        initValid: false,
        rule: (value) => ValidationHelper.isPassword(value) || value.length === 0
      },
      passwordConfirm: {
        defaultValue: "",
        initValid: false,
        rule: (value) => this.state.validation.password && value === this.state.validation.password.value,
      },
      hasMFA: {
        defaultValue: false,
        initValid: true,
        rule: ValidationHelper.isBoolean
      }
    };

    this.state = {
      validation: ValidationHelper.getValidation(this.validationDefinition),
      addedMembers: new Set(),
      mfaKeyUri: null
    };

    this.handleChange = this.handleChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onHide = this.onHide.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.show && this.props.show !== prevProps.show) {
      this.setState({
        validation: ValidationHelper.getValidation(
          {
            role: {
              defaultValue: this.props.user.role,
              rule: (value) => ValidationHelper.isIntInRange(value, 0, 1),
            },
            hasInternalLogin: {
              defaultValue: this.props.user.hasInternalLogin,
              initValid: true,
              rule: ValidationHelper.isBoolean
            },
            password: {
              defaultValue: "",
              initValid: true,
              rule: (value) => ValidationHelper.isPassword(value) || value.length === 0
            },
            passwordConfirm: {
              defaultValue: "",
              initValid: true,
              rule: (value) => this.state.validation.password && value === this.state.validation.password.value,
            },
            hasMFA: {
              defaultValue: this.props.user.hasMFA,
              initValid: true,
              rule: ValidationHelper.isBoolean
            }
          },
          true
        ),
      });
    } else if (!this.props.show && this.props.show !== prevProps.show) {
      this.setState({
        mfaKeyUri: null,
        validation: ValidationHelper.getValidation(
          this.validationDefinition,
          true
        ),
      });
    }
  }

  handleChange(event) {
    this.setState({
      validation: ValidationHelper.update(event, this.state.validation),
    });
  }

  onHide() {
    if (this.state.mfaKeyUri){
      this.props.onHide(false);
    }else{
      this.props.onHide(ValidationHelper.hasChanged(this.state.validation));
    }
  }

  async onSubmit() {
    if (this.state.validation._isValid) {
      const validatedData = ValidationHelper.getData(this.state.validation);
      if (validatedData["password"].length === 0) delete validatedData["password"];
      delete validatedData["passwordConfirm"];
      validatedData["userId"] = CamplaCoreService.getAuthenticatedUser()._id;
      const updatedUser = await this.props.onSubmit(validatedData);
      if (updatedUser && typeof updatedUser["mfaKeyUri"] !== "undefined"){
        this.setState({mfaKeyUri: updatedUser["mfaKeyUri"]});
      }
    }
  }

  render() {
    const { t } = this.props;

    const roles = [
      { label: "Lecturer", value: 0 },
      { label: "Administrator", value: 1 },
    ];

    return (
      <BaseDialog
        show={this.props.show}
        onHide={this.onHide}
        title={t("Users.UpdateModal.Title", {
          userName: this.props.userToDeleteOrEdit?.email,
        })}
        dialogApiError={this.props.dialogApiError}
        leftButtonCallback={this.onHide}
        leftButtonText={t("DialogCancel")}
        leftButtonVariant="black"
        rightButtonCallback={this.onSubmit}
        rightButtonText={t("Users.CreateModal.Form.Submit")}
        rightButtonVariant="green"
        rightButtonDisabled={!this.state.validation._isValid}
        body={
          <div style={this.props.isUpdating ? { textAlign: "center" } : {}}>
            {this.props.isUpdating ? (
              <Spinner animation="border" />
            ) : (
              <Form onSubmit={this.onSubmit}>
                {this.state.mfaKeyUri ? (
                    <>
                      <Alert variant="success">
                        {t("Users.UpdateModal.UpdateSuccessful")}
                      </Alert>
                      <Alert variant="info">
                        <Container>
                          <Row>
                            <Col>
                              <p>{t("Users.UpdateModal.Authenticator")}</p>
                            </Col>
                          </Row>
                          <Row>
                            <Col xs={9}>
                              <ul>
                                <li>Microsoft Authenticator</li>
                                <li>Google Authenticator</li>
                              </ul>
                            </Col>
                            <Col className="align-middle floatRight">
                              <div className="floatRight">
                                <QRCode
                                    value={this.state.mfaKeyUri}
                                    level="M"
                                    size={100}
                                />
                              </div>
                            </Col>
                          </Row>
                        </Container>
                      </Alert>
                    </>
                ) : ""}
                <Form.Group controlId="formUser">
                  <Form.Label>{t("Users.UpdateModal.Form.Role")}</Form.Label>
                  <BaseSelect
                    value={roles[this.state.validation.role.value]}
                    options={roles}
                    menuPosition="fixed"
                    id="formRole"
                    placeholder={t("Users.UpdateModal.Form.RolePlaceholder")}
                    onChange={(value) => {
                      this.handleChange({
                        target: {
                          name: "role",
                          value: value.value,
                        },
                      });
                    }}
                  />
                  <Form.Control
                    type="hidden"
                    isInvalid={!this.state.validation.role.isValid}
                  />
                  <Form.Group controlId="formInternalLogin" className="mt-2">
                    <hr />
                    <Form.Label>
                      {t(
                          "Users.UpdateModal.Form.InternalLogin"
                      )}{" "}
                    </Form.Label>
                    <Switch
                        className="float-right"
                        onColor="#54BF8D"
                        checked={this.state.validation.hasInternalLogin.value}
                        onChange={(state) => {
                          this.handleChange({
                            target: {
                              name: "hasInternalLogin",
                              value: state
                            }
                          });
                        }}
                        height={18}
                        width={40}
                    />
                    <Form.Control
                        type="hidden"
                        isInvalid={!this.state.validation.hasInternalLogin.isValid}
                    />
                  </Form.Group>
                  {this.state.validation.hasInternalLogin && this.state.validation.hasInternalLogin.value ? (
                      <>
                        <Form.Group controlId="formPassword">
                          <Form.Label>
                            {t("Users.UpdateModal.Form.Password")}
                          </Form.Label>
                          <Form.Control
                              type="password"
                              name="password"
                              value={this.state.validation.password.value}
                              isInvalid={!this.state.validation.password.isValid}
                              onChange={this.handleChange}
                          />
                          <Form.Control.Feedback type="invalid">
                            {t("Users.UpdateModal.Form.ValidationError.Password")}
                          </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group controlId="formPasswordConfirm">
                          <Form.Label>
                            {t("Users.UpdateModal.Form.PasswordConfirm")}
                          </Form.Label>
                          <Form.Control
                              type="password"
                              name="passwordConfirm"
                              value={this.state.validation.passwordConfirm.value}
                              isInvalid={!this.state.validation.passwordConfirm.isValid}
                              onChange={this.handleChange}
                          />
                          <Form.Control.Feedback type="invalid">
                            {t("Users.UpdateModal.Form.ValidationError.PasswordConfirm")}
                          </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group controlId="formHasMFA" className="mt-2">
                          <hr />
                          <Form.Label>
                            {t(
                                "Users.UpdateModal.Form.HasMFA"
                            )}{" "}
                          </Form.Label>
                          <Switch
                              className="float-right"
                              onColor="#54BF8D"
                              checked={this.state.validation.hasMFA.value}
                              onChange={(state) => {
                                this.handleChange({
                                  target: {
                                    name: "hasMFA",
                                    value: state
                                  }
                                });
                              }}
                              height={18}
                              width={40}
                          />
                          <Form.Control
                              type="hidden"
                              isInvalid={!this.state.validation.hasMFA.isValid}
                          />
                        </Form.Group>
                        <ul>
                          <li>Microsoft Authenticator</li>
                          <li>Google Authenticator</li>
                        </ul>
                      </>
                  ) : ""}
                </Form.Group>
              </Form>
            )}
          </div>
        }
      />
    );
  }
}

export default withTranslation()(UpdateUserDialog);
